<div class="dropdown">
    <a class="btn btn-outline-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
      Configuraciones
    </a>
    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink">
      <li>
        <a [routerLink]="['/admin/distributor/pv-group']" routerLinkActive="active" class="dropdown-item">Grupos PV</a>
      </li>
      <li>
        <a [routerLink]="['/admin/distributor/vn-plate']" routerLinkActive="active" class="dropdown-item">Placas VN</a>
      </li>
      <li>
        <a [routerLink]="['/admin/distributor/sector']" routerLinkActive="active" class="dropdown-item">Sectores</a>
      </li>
      <li>
        <a [routerLink]="['/admin/distributor/region']" routerLinkActive="active" class="dropdown-item">Regiones</a>
      </li>
      <li>
        <a [routerLink]="['/admin/distributor/installation-relation']" routerLinkActive="active" class="dropdown-item">Relaciones (instalación)</a>
      </li>
      <li>
        <a [routerLink]="['/admin/distributor/installation-statute']" routerLinkActive="active" class="dropdown-item">Estatuto (instalación)</a>
      </li>
    </ul>
  </div>